<template>
  <page-with-aside :hasFooter="true">
    <header class="page-header">
      <!-- already logged in so hide login button -->
      <nav>
        <router-link to="/about" class="button">About the Program</router-link>
      </nav>
    </header>

    <template #content>
      <section class="content">
        <h2>Study eligibility</h2>
        <h4>
          Thank you for your interest in Open to Options. Before we begin, we
          have a few quick questions to make sure you’re eligible to
          participate.
        </h4>
        <form ref="form" @submit="handleSubmit">
          <section class="">
            <div class="group">
              <ul
                v-for="(error, errorIndex) in errors"
                :key="'error_' + errorIndex"
                class="oops"
              >
                <li v-html="error" />
              </ul>

              <label>
                <h5>
                  <strong>Enter your access code</strong>
                </h5>
              </label>
              <p style="font-style: italic">
                The access code is in the introduction email that you received.
              </p>
              <input type="text" v-model="accessCode" required />
              <ul
                v-for="(accessCodeError,
                accessCodeErrorIndex) in accessCodeErrors"
                :key="'accessCodeError_' + accessCodeErrorIndex"
                class="oops"
              >
                <li v-html="accessCodeError" />
              </ul>
            </div>

            <div class="group">
              <label>What is your current age?</label>
              <ul
                v-for="(ageError, ageErrorIndex) in ageErrors"
                :key="ageErrorIndex"
                class="oops"
              >
                <li v-html="ageError" />
              </ul>
              <input v-model="age" name="age" type="text" required />

              <label class="col-md-4 control-label" for="radios"
                >Are you comfortable speaking and reading in English?</label
              >
              <ul
                v-for="(englishError, englishErrorIndex) in englishErrors"
                :key="'englishError_' + englishErrorIndex"
                class="oops"
              >
                <li v-html="englishError" />
              </ul>

              <label class="radio-inline" for="radios-0">
                <input
                  type="radio"
                  name="english"
                  value="yes"
                  v-model="english"
                  checked="checked"
                  required
                />
                Yes
              </label>
              <label class="radio-inline" for="radios-1">
                <input
                  type="radio"
                  name="english"
                  value="no"
                  v-model="english"
                  required
                />
                No
              </label>
            </div>

            <!-- Multiple Radios (inline) -->
            <div class="group">
              <label class="col-md-4 control-label" for="radios"
                >Do you have an appointment scheduled with a doctor at a cancer center/hospital in the next 3 weeks?</label
              >
              <ul
                v-for="(apptError, apptErrorIndex) in apptErrors"
                :key="'apptError_' + apptErrorIndex"
                class="oops"
              >
                <li v-html="apptError" />
              </ul>

              <label class="radio-inline" for="radios-0">
                <input
                  type="radio"
                  value="yes"
                  name="appt"
                  checked="checked"
                  v-model="appt"
                  required
                />
                Yes
              </label>
              <label class="radio-inline" for="radios-1">
                <input
                  type="radio"
                  value="no"
                  name="appt"
                  v-model="appt"
                  required
                />
                No
              </label>

              <div v-if="appt == 'yes'">
                <ul
                  v-for="(apptDateError, apptDateErrorIndex) in apptDateErrors"
                  :key="'apptDateError_' + apptDateErrorIndex"
                  class="oops"
                >
                  <li v-html="apptDateError" />
                </ul>

                <label>What is the date of your appointment?</label>
                <datepicker
                  v-model="apptDate"
                  name="appt_date"
                  format="yyyy-M-d"
                  inline
                ></datepicker>
              </div>
            </div>
          </section>
          <button type="submit">
            <!-- router-link to="/accountsetup">Take me to account setup</router-link> -->
            Continue
          </button>
        </form>
      </section>
    </template>
  </page-with-aside>
</template>
<style scoped lang="scss">
.radio-inline {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  input {
    width: 2em;
  }
}
ul.oops {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    color: #c72231;
    background-color: #f6dfdc;
    padding: 0.5rem 1rem;
    border: 1px solid #c72231;
    font-weight: bold;
  }
}
</style>
<script>
import PageWithAside from "@/components/PageWithAside.vue";
import { axios } from "@/main.js";
import Datepicker from "vuejs-datepicker";
import { mapMutations } from "vuex";

export default {
  name: "Eligibility",

  data() {
    return {
      accessCode: "",
      age: null,
      english: null,
      appt: null,
      apptDate: null,
      accessCodeErrors: [],
      ageErrors: [],
      englishErrors: [],
      apptErrors: [],
      apptDateErrors: [],
      eligibilityStatus: "",
      errors: [],
    };
  },

  components: {
    PageWithAside,
    Datepicker,
  },

  methods: {
    ...mapMutations(["setAccessCode"]),

    clearErrors() {
      this.accessCodeErrors = [];
      this.ageErrors = [];
      this.englishErrors = [];
      this.apptErrors = [];
    },

    handleSubmit(event) {
      event.preventDefault();
      this.setAccessCode(this.accessCode);
      this.sendEligibilityData();
    },

    sendEligibilityData() {
      var formData = new FormData(this.$refs.form);
      let self = this;

      this.clearErrors();
      let url = "/api/eligible/" + this.accessCode + "/";

      axios
        .put(url, formData)
        .then(function (response) {
          let status = response.status;

          switch (status) {
            case 200: // success
              let eligibility_status = response.data["eligibility_status"];

              if (eligibility_status == "eligible") {
                self.$router.push("/accountsetup/" + self.accessCode);
              }

              if (eligibility_status == "ineligible") {
                self.$router.push("/ineligible");
              }

              if (eligibility_status == "pending") {
                self.$router.push("/ineligible/pending");
              }

              break;

            default:
              break;
          }
        })
        .catch(function (error) {
          let status = error.response.status;
          self.errors.push[error.response.statusText];
          switch (status) {
            case 400: // bad request
              self.errors = error.response.data;
              self.ageErrors = error.response.data["age"];
              self.englishErrors = error.response.data["english"];
              self.apptErrors = rerror.response.data["appt"];
              self.apptDateErrors = error.response.data["appt_date"];
              break;

            case 404: // not found
              self.accessCodeErrors = ["No such access code."];
              break;
          }
        });
    },
  },
};
</script>